import request from '@/util/request';

/** 获取用户信息 */
export const getUserInfoInDirect = async () => {
  let data;
  data = await request('/ec-manage/platform/account/queryAccountInfo', {
    method: 'GET',
  });
  return data;
};


/** 获取用户信息 */
export const getUserInfoInOperate = async () => {
  let data;
  data = await request('/equipment-maintenance/user/userInfo', {
    method: 'GET',
  });
  if (data) {
    data.realPhone = data?.cellphone;
  }
  if (!data) {
    data = await request('/open-platform-web/api/index/queryLoginUserInfo', {
      method: 'GET',
    });
  }
  return data;
};
